
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.27 24.52v11a3.78 3.78 0 01-3.79 3.79h-21a3.78 3.78 0 01-3.79-3.79v-21a3.78 3.78 0 013.79-3.79h11M30.68 10.73h7.88a.71.71 0 01.71.71V19M38.56 11.44l-9.41 9.41","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"3px"}})])
          )
        }
      }
    